import { useTranslation } from 'react-i18next';
import styles from './TechLibraryDocPanel.module.scss';
import { DrawerPanel, ConnectivitySnackbar } from '@dmc/ui';
import Skeleton from 'react-loading-skeleton';
import { useLocaleFormatter } from '@customer/shared/hooks/useLocaleFormatter';
import useTechLibrary from './useTechLibrary';
import { VdsBadgePill, VdsButton, VdsIcon } from '@volt/volt-extended-components-react';

const onDownload = (uri?: string) => {
  if (uri) {
    window.open(uri, '_blank', 'noopener,noreferrer');
  }
};

export function TechLibraryDocPanel() {
  const { t } = useTranslation();
  const { showDateOnlyFromIso } = useLocaleFormatter();

  const { doc, error } = useTechLibrary();

  return (
    <>
      <DrawerPanel
        header={
          <div className={styles.header}>
            <div className={styles.header__titleRow}>
              {doc ? doc.title : <Skeleton width="200px" height="36px" />}
            </div>
            <div className={styles.header__subtitleRow}>
              <div className={styles.subtitle}>
                {doc ? t(`DocType.${doc.documentType}`) : <Skeleton width="150px" />}
              </div>
              <div className={styles.reference}>
                {doc ? doc.releaseVersion : <Skeleton width="150px" />}
              </div>
              {doc ? (
                <div className={styles.timestamp}>{showDateOnlyFromIso(doc.releaseDate)}</div>
              ) : (
                <Skeleton width="150px" />
              )}
            </div>
          </div>
        }
        footer={
          <VdsButton
            onClick={_ => onDownload(doc?.downloadUri)}
            variant="primary"
            size="medium"
            isFullWidth
          >
            {t('Download')}
            <VdsIcon slot="icon-left" svgIcon="download"></VdsIcon>
          </VdsButton>
        }
      >
        {doc && (
          <div className={styles.body}>
            {doc.productFamilies.length > 0 && (
              <div className={styles.frame}>
                <div className={styles.label}>{t('ProductFamily')}</div>
                <div className={styles.chips}>
                  {doc.productFamilies.map(family => (
                    <VdsBadgePill
                      key={family}
                      value={t('DocProductFamily.' + family)}
                      size="extra-small"
                      statusColor="information"
                    />
                  ))}
                </div>
              </div>
            )}

            {doc.products.length > 0 && (
              <div className={styles.frame}>
                <div className={styles.label}>{t('Product')}</div>
                <div className={styles.chips}>
                  {doc.products.map(family => (
                    <VdsBadgePill
                      key={family}
                      value={t('DocProduct.' + family)}
                      size="extra-small"
                      statusColor="information"
                    />
                  ))}
                </div>
              </div>
            )}

            <div className={styles.description}>{doc.description}</div>
          </div>
        )}
      </DrawerPanel>

      <ConnectivitySnackbar error={error} message={t('FetchDocError')} title={t('Error')} />
    </>
  );
}

export default TechLibraryDocPanel;
